import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';
/**
 * @deprecated we no longer maintain this component
 */

var StandardHeroTextBackgroundImage = deprecatedComponent({
  displayName: 'StandardHeroTextBackgroundImage',
  description: 'StandardHeroTextBackgroundImage is Deprecated.',
  root: createComponent({
    displayName: 'StandardHeroTextBackgroundImage',
    root: 'div',
    propConfig: {
      classNames: ['swan-standard-hero-text-background-image']
    }
  })
});
export { StandardHeroTextBackgroundImage };